import {
  type PermissionRouteGuardData,
  PermissionRouteGuard,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QSetReviewTaskProvider } from '@exam-management/qset-review-task-detail';
import { useParams } from '@exam-management/router';
import {
  QSetReviewModalProvider,
  TaskManagementPermissionRoute,
} from '@exam-management/task-management';
import { Outlet } from 'react-router-dom';

export default function QSetReviewTaskLayout() {
  const { taskId } = useParams('/task-management/qset-review/:taskId');
  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/task-management/qset-review/:taskId',
      requiredPermission: [APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/qset-review/:taskId/qset/:qSetId/review-result',
      requiredPermission: [APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/qset-review/:taskId/qset/:qSetId/review-result/exam-details',
      requiredPermission: [APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW],
      params: {
        taskId,
      },
    },
  ];
  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <TaskManagementPermissionRoute taskId={taskId}>
        <QSetReviewTaskProvider taskId={taskId}>
          <QSetReviewModalProvider>
            <Outlet />
          </QSetReviewModalProvider>
        </QSetReviewTaskProvider>
      </TaskManagementPermissionRoute>
    </PermissionRouteGuard>
  );
}
